module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b757d5b397edb5106c75f5823d3cb8ff.png";